<template>
    <div class="container" style="height:calc(100vh - 100px)">
        <v-row>
            <v-col
                cols="12"
                offset-md="2"
                md="7">
                <v-skeleton-loader
                v-if="!isLoadIframe"
                type="image, list-item-avatar, card-heading, divider, list-item-three-line, divider, list-item-three-line, divider, list-item-three-line, divider, list-item-three-line, divider, list-item-three-line, actions"
                ></v-skeleton-loader>
            </v-col>
        </v-row>
        <iframe id="iFrameCross" @load="loadIframe"
        :src="`https://docs.google.com/forms/d/e/1FAIpQLSfSK44yoqK_IT3HHpwrlmT6GeWY1XUOhmsQPajAXoKYKjwBpQ/viewform?entry.2005620554=testingNombre&entry.1045781291=testingCorreo@yopmail.com`"
        width="100%"
        class="iframecross"
        style="display:none;height:calc(100vh - 120px)"
        frameborder="0" >
        </iframe>
    </div>
</template>
<script>
export default {
    name:"Cross",
    data: ()=>({
        isLoadIframe:false
    }),
    methods:{
        loadIframe(){
            this.isLoadIframe = true;
            document.querySelector("#iFrameCross").style.display = "block";
        }
    }
}
</script>
<style>
    .iframecross{
        height:"100px"
    }
</style>